import "./Input.css";

const Input = ({ prefix, suffix, className, ...restProps }: any) => {
  return (
    <div className={`input-wrapper ${className}`}>
      {prefix && <span>{prefix}</span>}
      <input className="input-class" {...restProps} />
      {suffix && <span>{suffix}</span>}
    </div>
  );
};

export default Input;
